import { StytchUIClient } from '@stytch/vanilla-js';
import { isStytchEnabled, stytchDomain as runtimeStytchDomain, stytchPublicToken } from './runtimeConfig';
import { STYTCH_SESSION_DURATION_MINUTES } from './stytchSession';

export const stytchLoginDomain =
  runtimeStytchDomain;

export const stytchEnvironment = stytchLoginDomain.includes('login.cloud.hermetiq.io')
  ? 'live'
  : 'test';

const hostname = typeof window !== 'undefined' ? window.location.hostname : '';

export const cookieDomain = stytchLoginDomain.includes('login.cloud.hermetiq.io')
  ? '.hermetiq.io'
  : (hostname === 'localhost' ? hostname : '.hermetiq.dev');

export const cookieOptions = {
  // Share the dashboard Stytch session across Hermetiq SaaS subdomains so
  // Grafana, Buildbarn Browser, and other protected subdomain apps can SSO.
  domain: cookieDomain,
  path: '/',
  availableToSubdomains: true,
};

export const stytchClient = isStytchEnabled
  ? new StytchUIClient(stytchPublicToken, {
      environment: stytchEnvironment,
      cookieOptions,
      keepSessionAlive: true,
      customBaseUrl: stytchLoginDomain,
      sessionOptions: {
        sessionDurationMinutes: STYTCH_SESSION_DURATION_MINUTES,
      },
      userAgent: {
        name: 'Hermetiq Dashboard',
        version: '1.0.0',
        url: 'https://dashboard.hermetiq.io',
      },
    })
  : null;
